import { render, staticRenderFns } from "./multiImageUpload.vue?vue&type=template&id=2ed799cc&scoped=true"
import script from "./multiImageUpload.vue?vue&type=script&lang=js"
export * from "./multiImageUpload.vue?vue&type=script&lang=js"
import style0 from "./multiImageUpload.vue?vue&type=style&index=0&id=2ed799cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed799cc",
  null
  
)

export default component.exports